import { useScript } from "hooks/use-script"

/**
 * AdwordsConversionScript injects Google AdWords conversion tracking after signup.
 *
 * IF THIS COMPONENT IS UPDATED, UPDATE THE RAILS PARTIAL AT app/views/layouts/client_script_config/_adwords.html.erb
 *
 * @param {number} planAmount - The plan amount
 */
export function AdwordsConversionScript({ planAmount }) {
  window.google_conversion_id = 849421020
  window.google_conversion_language = "en"
  window.google_conversion_format = "3"
  window.google_conversion_color = "ffffff"
  window.google_conversion_label = "YVmSCPnmhXMQ3MWElQM"
  window.google_remarketing_only = false
  window.google_conversion_value = planAmount || 0

  useScript("https://www.googleadservices.com/pagead/conversion.js")
}
